
import MicrophoneSlash from "../../../assets/duotone/MicrophoneSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MicrophoneSlashIcon({ className, dataTestid = "MicrophoneSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MicrophoneSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
